const storageKey = "TOKEN";
const timeOutDonateChart = 10;

export { storageKey, timeOutDonateChart };
